import { PlayerSide } from "../ai/TableAI";
import { CardSuit } from "../card/Card";

export function GetCardSuitsExcept(cardSuit: CardSuit): CardSuit[]
{
    switch(cardSuit) {
        case CardSuit.HEARTS: return [CardSuit.SPADES, CardSuit.CLUBS, CardSuit.DIAMONDS];
        case CardSuit.DIAMONDS: return [CardSuit.SPADES, CardSuit.CLUBS, CardSuit.HEARTS];
        case CardSuit.CLUBS: return [CardSuit.SPADES, CardSuit.DIAMONDS, CardSuit.HEARTS];
        case CardSuit.SPADES: return [CardSuit.CLUBS, CardSuit.DIAMONDS, CardSuit.HEARTS];
    }
}